// theme.js
const theme = {
  token: {
    colorPrimary: '#F15637',
    colorInfo: '#14557B',
    colorSuccess: '#259BE1',
    colorWarning: '#FBA840',
    colorError: '#ff4d4f',
    colorTextBase: '#2f2f2f',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    borderRadius: 8,
  },
  components: {
    Button: {
      borderRadius: 30,
      controlHeight: 40,
    },
    Card: {
      borderRadius: 8,
    },
    Input: {
      borderRadius: 8,
    },
  }
};

export default theme; 